<template>
<div
    v-if="value != null"
    class="blob-container"
>
    <img
        :src="img_src_url"
        :style="image_style"
    /> 

    <br/>

    <v-icon
        v-on:click="onClickDelete"
    >
        mdi-trash-can-outline
    </v-icon>
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; }
        },

        max_size: {
            type: Number,
            default: function() { return 300; }
        },
    },

    methods: {
        onClickDelete() {
            this.$emit('delete');
        },
    },

    computed: {
        img_src_url() {
            if ( this.value == null ) 
                return null;

            return 'https://files.redchirp.com/'+this.value.object_name;
        },

        image_style() {
            return 'max-width: '+this.max_size+'px; max-height: '+this.max_size+'px';
        },
    },
}
</script>

<style lang="scss" scoped>

.blob-container
{
    border: 1px solid rgba(0,0,0,0.2); 
    border-radius: 15px; 
    float: left; 
    margin-left: 15px; 
    margin-right: 15px; 
    margin-bottom: 15px; 
    margin-top: 15px; 
    text-align: center; 
    padding: 15px; 
    position: relative;
}

</style>